import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, TextField } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { EditorialTemplate } from '../../domain/domain';

type Props = {
    open: boolean,
    editorialTemplate: EditorialTemplate | undefined,
    mode: 'add' | 'edit',
    onOK: (title: string) => void,
    onCancel: () => void
}

const AddEditorialTemplateDialog : React.FC<Props> = ({editorialTemplate, mode, open, onOK, onCancel}) => {

    const [templateTitle, setTemplateTitle] = useState<string>(editorialTemplate !== undefined ? editorialTemplate.title : '');

    useEffect(() => {
        if (open) {
            setTemplateTitle(editorialTemplate !== undefined ? editorialTemplate.title : '');
        }
    }, [open])

    function isFormValid() {
        return templateTitle !== undefined && templateTitle.length > 0;
    }
    
    return (
        <Dialog open={open} onClose={() => onCancel()} maxWidth='md'>
            <DialogTitle>{mode === 'add' ? 'Add Editorial Template' : 'Edit Editorial Template'}</DialogTitle>
            <DialogContent style={{width: 400}}>
                <TextField value={templateTitle} variant='outlined' placeholder='Template Title' size='small' style={{width: '100%'}} autoFocus={true} onChange={(event) => {
                    setTemplateTitle(event.target.value);
                }}>
                </TextField>
            </DialogContent>
            <DialogActions>
                <Button size='small' variant='outlined' color='secondary' onClick={onCancel} >Cancel</Button>
                {mode === 'add' && 
                    <Button size='small' variant='outlined' color='secondary' onClick={() => onOK(templateTitle)} disabled={!isFormValid()}>Add</Button>
                }
                {mode === 'edit' && 
                    <Button size='small' variant='outlined' color='secondary' onClick={() => onOK(templateTitle)} disabled={!isFormValid()}>Update</Button>
                }
            </DialogActions>
        </Dialog>
    )
}

export default AddEditorialTemplateDialog;